import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink, Image, BlobProvider, pdf } from "@react-pdf/renderer";
import moment from "moment";
import { numeral, setLocale } from "../../";
import { ListItemText, makeStyles } from "@material-ui/core";
import selects from "../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    link: {
      textDecoration: "none"
    }
  };
});
var styles = StyleSheet.create({
  logo: {
    width: "30%"
  },
  billData: {
    width: "70%",
    alignItems: "flex-end",
    justifyContent: "center"
  },
  header: {
    marginBottom: "16px",
    display: "flex",
    flexDirection: "row",
    padding: "16px"
  },
  personsData: {
    display: "flex",
    flexDirection: "row",
    width: "60%",
    marginLeft: "20%",
    marginTop: "16px"
  },
  personData: {
    fontSize: 10,
    width: "50%",
    alignItems: "center",
    display: "flex",
    "flex-direction": "column"
  },
  dates: {
    width: "100%",
    textAlign: "right",
    fontSize: 10,
    paddingRight: "16px",
    marginBottom: "16px"
  },
  //table
  tableRow: {
    margin: "auto",
    flexDirection: "row",
    borderRight: 1,
    borderBottom: 1,
    borderLeft: 1
  },
  tableRowHeader: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: "#a2a2a2"
  },
  tableRowBody: {
    margin: "auto",
    flexDirection: "row",
    borderRight: 1,
    borderBottom: 1,
    borderLeft: 1
  },
  tableCellHeader: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    paddingBottom: 4
  },
  tableCell: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 10
  },
  tableSmallCell: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 8
  },
  tableBigCell: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 12
  },
  tableSmallCellLeft: {
    margin: "auto",
    marginLeft: 0,
    paddingLeft: 3,
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 8
  },
  tableCellLeft: {
    margin: "auto",
    marginLeft: 0,
    paddingLeft: 3,
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 10
  },
  tableCellBold: {
    margin: "auto",
    paddingTop: 5,
    paddingBottom: 3,
    fontSize: 10,
    fontWeight: 900
  },
  colConcept: {
    width: "40%"
  },
  colCuantity: {
    width: "10%"
  },
  colPrice: {
    width: "10%"
  },
  colSubtotal: {
    width: "10%"
  },
  colTypeTax: {
    width: "10%"
  },
  colTax: {
    width: "10%"
  },
  colTotal: {
    width: "10%"
  },
  container: {
    flexDirection: "row",
    "@media max-width: 400": {
      flexDirection: "column"
    }
  },
  leftColumn: {
    flexDirection: "column",
    width: 170,
    marginLeft: 30,
    marginRight: 15,
    marginTop: 20,
    "@media max-width: 400": {
      width: 290,
      marginRight: 30
    },
    "@media orientation: landscape": {
      width: 200,
      marginRight: 50
    }
  },
  rightColumn: {
    flexDirection: "column",
    flexGrow: 1,
    flexShrink: 1,
    marginLeft: 15,
    marginRight: 30,
    marginTop: 20,
    borderStyle: "dashed solid double",
    border: 1,
    borderWidth: 2,
    "@media max-width: 400": {
      marginTop: 10,
      marginLeft: 30
    }
  },
  table: {
    display: "table",
    width: "100%",
    flexDirection: "column",
    flexShrink: 1,
    padding: "16px"
  },
  tableColHeader: {
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    width: "17%"
  },
  tableCol: {
    flexGrow: 1,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  colType: {
    width: "30%",
    backgroundColor: "#a2a2a2"
  },
  colImport: {
    width: "30%"
  },
  paymentMethod: {
    backgroundColor: "#a2a2a2",
    borderRadius: 4,
    width: "60%",
    marginLeft: "20%",
    marginBottom: 32
  }
});

var MyDocument = function MyDocument(_ref) {
  var data = _ref.data,
      translation = _ref.translation;
  // console.log("MyDocument", data, translation);
  return /*#__PURE__*/React.createElement(Document, null, /*#__PURE__*/React.createElement(Page, {
    size: "A4"
  }, /*#__PURE__*/React.createElement(View, {
    fixed: true,
    style: styles.header
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.logo
  }, /*#__PURE__*/React.createElement(Image, {
    source: "https://sm-logos-23132.s3.eu-west-3.amazonaws.com/black-logo.png"
  })), /*#__PURE__*/React.createElement(View, {
    style: styles.billData
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.titleBill
  }, translation ? translation.docnumber : "Invoice number", ":", " ", data.docnumber ? data.docnumber : null))), /*#__PURE__*/React.createElement(View, {
    style: styles.dates,
    fixed: true
  }, /*#__PURE__*/React.createElement(Text, null, translation ? translation.date : "Document date: ", " ", data.date ? moment(data.date).format("DD-MM-YYYY") : null), /*#__PURE__*/React.createElement(Text, null, translation ? translation.due_date : "Due Date: ", " ", data.due_date ? moment(data.due_date).format("DD-MM-YYYY") : null)), /*#__PURE__*/React.createElement(View, {
    style: styles.personsData
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.personData
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.personType
  }, translation ? translation.issuer : "Issuer:"), /*#__PURE__*/React.createElement(Text, null, data.issuer ? !data.issuer.billingInfo.isLegalEntity ? [data["issuer"].billingInfo.name ? data["issuer"].billingInfo.name : null, data["issuer"].billingInfo.firstSurname !== undefined ? data["issuer"].billingInfo.firstSurname : "", data["issuer"].billingInfo.lastSurname !== undefined ? data["issuer"].billingInfo.lastSurname : ""] : data.issuer.billingInfo.name : null), /*#__PURE__*/React.createElement(Text, null, data.issuer ? data.issuer.billingInfo.vat_number : null), /*#__PURE__*/React.createElement(Text, null, data.issuer ? data.issuer.billingInfo.address : null), /*#__PURE__*/React.createElement(Text, null, data.issuer ? data.issuer.billingInfo.zipcode : null, " ", data.issuer ? data.issuer.billingInfo.town : null, " ", data.issuer ? data.issuer.billingInfo.province : null)), /*#__PURE__*/React.createElement(View, {
    style: styles.personData
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.personType
  }, translation ? translation.receiver : "Receiver"), data ? data.type == "in" ? [data.franchise.billingInfo.isLegalEntity ? /*#__PURE__*/React.createElement(Text, null, data["franchise"].billingInfo.name ? data["franchise"].billingInfo.name : null) : /*#__PURE__*/React.createElement(Text, null, data["franchise"].billingInfo.name ? "".concat(data["franchise"].billingInfo.name, " ").concat(data["franchise"].billingInfo.firstSurname, " ").concat(data["franchise"].billingInfo.lastSurname) : null), /*#__PURE__*/React.createElement(Text, null, data["franchise"].billingInfo.address ? data["franchise"].billingInfo.address : null, " "), /*#__PURE__*/React.createElement(Text, null, " ", data["franchise"].billingInfo.zipcode ? data["franchise"].billingInfo.zipcode : null, " ", data["franchise"].billingInfo.town ? data["franchise"].billingInfo.town : null, " ", data["franchise"].billingInfo.province ? data["franchise"].billingInfo.province : null), /*#__PURE__*/React.createElement(Text, null, data["franchise"].billingInfo.vat_number ? data["franchise"].billingInfo.vat_number : null)] : [/*#__PURE__*/React.createElement(Text, null, data["client"].billingInfo.name ? data["client"].billingInfo.name : null, data["client"].billingInfo.firstSurname !== undefined ? data["client"].billingInfo.firstSurname : "", data["client"].billingInfo.lastSurname !== undefined ? data["client"].billingInfo.lastSurname : ""), /*#__PURE__*/React.createElement(Text, null, " ", data["client"].billingInfo.address ? data["client"].billingInfo.address : null, " "), /*#__PURE__*/React.createElement(Text, null, data["client"].billingInfo.zipcode ? data["client"].billingInfo.zipcode : null, " ", data["client"].billingInfo.town ? data["client"].billingInfo.town : null, " ", data["client"].billingInfo.province ? data["client"].billingInfo.province : null), /*#__PURE__*/React.createElement(Text, null, data["client"].billingInfo.vat_number ? data["client"].billingInfo.vat_number : null)] : null)), /*#__PURE__*/React.createElement(View, {
    style: styles.table,
    wrap: true
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.tableRowHeader
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.colConcept
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.name : "Concept")), /*#__PURE__*/React.createElement(View, {
    style: styles.colCuantity
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.quantity : "Quantity")), /*#__PURE__*/React.createElement(View, {
    style: styles.colPrice
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.price : "Price")), /*#__PURE__*/React.createElement(View, {
    style: styles.colSubtotal
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.subtotal : "Subtotal")), /*#__PURE__*/React.createElement(View, {
    style: styles.colTypeTax
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.tax.label : "Tax")), /*#__PURE__*/React.createElement(View, {
    style: styles.colTax
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.tax.amount : "Tax amount")), /*#__PURE__*/React.createElement(View, {
    style: styles.colTotal
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.items.total : "Total"))), data ? data.items.map(function (item, i) {
    var tax = translation ? translation.taxes.find(function (tx) {
      return tx.value === item.tax;
    }) : selects.taxes.find(function (tx) {
      return tx.value === item.tax;
    });
    return /*#__PURE__*/React.createElement(View, {
      style: styles.tableRow
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.colConcept
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCellLeft
    }, item.name ? item.name : null), /*#__PURE__*/React.createElement(Text, {
      style: styles.tableSmallCellLeft
    }, item.description ? item.description : null)), /*#__PURE__*/React.createElement(View, {
      style: styles.colCuantity
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, item.qty, " ")), /*#__PURE__*/React.createElement(View, {
      style: styles.colPrice
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, item.price ? numeral(item.price).format("0,0[.]00 $") : null)), /*#__PURE__*/React.createElement(View, {
      style: styles.colSubtotal
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, item.subtotal ? numeral(item.subtotal).format("0,0[.]00 $") : null)), tax ? [/*#__PURE__*/React.createElement(View, {
      style: styles.colTypeTax
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableSmallCell
    }, tax.label)), /*#__PURE__*/React.createElement(View, {
      style: styles.colTax
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, numeral(item.subtotal * tax.percentage).format("0,0[.]00 $")))] : null, /*#__PURE__*/React.createElement(View, {
      style: styles.colTotal
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.tableCell
    }, item.total ? numeral(item.total).format("0,0[.]00 $") : null)));
  }) : null), /*#__PURE__*/React.createElement(View, {
    style: styles.table,
    wrap: true
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.tableRowBody
  }, /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles.colType), {}, {
      borderTop: 1
    })
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.subtotal : "Subtotal")), /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles.colImport), {}, {
      borderTop: 1
    })
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCell
  }, data.subtotal ? numeral(data.subtotal).format("0,0[.]00 $") : null))), /*#__PURE__*/React.createElement(View, {
    style: styles.tableRowBody
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.colType
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.tax : "Tax")), /*#__PURE__*/React.createElement(View, {
    style: styles.colImport
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCell
  }, data.tax ? numeral(data.tax).format("0,0[.]00 $") : null))), data.irpf ? /*#__PURE__*/React.createElement(View, {
    style: styles.tableRowBody
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.colType
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, "IRPF (", data.irpf, "%)")), /*#__PURE__*/React.createElement(View, {
    style: styles.colImport
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCell
  }, data.irpf ? numeral(data.irpf / 100 * data.subtotal).format("0,0[.]00 $") : null))) : null, /*#__PURE__*/React.createElement(View, {
    style: styles.tableRowBody
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.colType
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, translation ? translation.total : "Total")), /*#__PURE__*/React.createElement(View, {
    style: styles.colImport
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCellHeader
  }, data.total ? numeral(data.total).format("0,0[.]00 $") : null)))), data.message ? /*#__PURE__*/React.createElement(View, {
    wrap: true,
    style: styles.paymentMethod
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableBigCell
  }, data.message ? data.message : null)) : null, /*#__PURE__*/React.createElement(View, {
    wrap: true,
    style: styles.paymentMethod
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.tableCell
  }, translation ? translation.method : "Payment method"), /*#__PURE__*/React.createElement(Text, {
    style: styles.tableBigCell
  }, data.payment_method ? data.payment_method.name ? data.payment_method.name.toUpperCase() : null : null), /*#__PURE__*/React.createElement(Text, {
    style: styles.tableBigCell
  }, data.payment_method ? data.payment_method.account_number : null), data.payment_method ? data.payment_method.message ? /*#__PURE__*/React.createElement(Text, {
    style: styles.tableBigCell
  }, data.payment_method ? data.payment_method.message : null) : null : null), /*#__PURE__*/React.createElement(View, {
    style: {
      justifySelf: "flex-end",
      alignItems: "center"
    },
    fixed: true
  }, /*#__PURE__*/React.createElement(Text, {
    fixed: true,
    render: function render(_ref2) {
      var pageNumber = _ref2.pageNumber,
          totalPages = _ref2.totalPages;
      return totalPages > 1 ? "".concat(pageNumber, " / ").concat(totalPages) : null;
    }
  }))));
};

var PdfViewer = function PdfViewer(props) {
  var classes = useStyles(); // console.log("PdfViewer props", props);

  if (props.variant === "downloader") {
    return /*#__PURE__*/React.createElement(PDFDownloadLink, {
      document: /*#__PURE__*/React.createElement(MyDocument, props),
      fileName: props.filename + ".pdf",
      className: classes.link
    }, function (_ref3) {
      var blob = _ref3.blob,
          url = _ref3.url,
          loading = _ref3.loading,
          error = _ref3.error;
      return loading ? /*#__PURE__*/React.createElement(Text, null, props.translation ? props.translation.loading : "Loading file") : /*#__PURE__*/React.createElement(Text, null, props.translation ? props.translation.download : "Download");
    });
  } else if (props.variant === "blobprovider") {
    return /*#__PURE__*/React.createElement(BlobProvider, {
      document: /*#__PURE__*/React.createElement(MyDocument, props)
    }, function (_ref4) {
      var blob = _ref4.blob,
          url = _ref4.url,
          loading = _ref4.loading,
          error = _ref4.error;
      return loading ? null : props.handleFinishLoading(blob);
    });
  } else {
    return /*#__PURE__*/React.createElement(PDFViewer, {
      style: {
        width: "90%",
        height: "100vh"
      }
    }, /*#__PURE__*/React.createElement(MyDocument, props));
  }
};

export { PdfViewer, MyDocument };